import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftContainerRegistryServer } from "namirasoft-container-registry";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ContainerRegistryLayout } from "./ContainerRegistryLayout";
import { ContainerRegistryRoutes } from "./ContainerRegistryRoutes";
import ContainerRegistryEditPage from "./pages/ContainerRegistryEditPage";
import ContainerRegistryListPage from "./pages/ContainerRegistryListPage";
import ContainerRegistryViewPage from "./pages/ContainerRegistryViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_CONTAINER_REGISTRY}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_CONTAINER_REGISTRY = new EnvService("REACT_APP_BASE_URL_CONTAINER_REGISTRY", true).getString();

            let container_registry = new NamirasoftContainerRegistryServer(REACT_APP_BASE_URL_CONTAINER_REGISTRY, result.account.token_manager, result.notifier.onError);

            let servers = { container_registry };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={ContainerRegistryRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={ContainerRegistryRoutes.ContainerRegistryList} element={<ContainerRegistryListPage {...result} servers={servers} />} />
                            <Route path={ContainerRegistryRoutes.ContainerRegistryNew} element={<ContainerRegistryEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ContainerRegistryRoutes.ContainerRegistryView(":id")} element={<ContainerRegistryViewPage {...result} servers={servers} />} />
                            <Route path={ContainerRegistryRoutes.ContainerRegistryEdit(":id")} element={<ContainerRegistryEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ContainerRegistryRoutes.ContainerRegistryCopy(":id")} element={<ContainerRegistryEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={ContainerRegistryRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <ContainerRegistryLayout {...props}>
                {props.children}
            </ContainerRegistryLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;